import { render, staticRenderFns } from "./ModalSendCaseToOrg.vue?vue&type=template&id=481535a3&scoped=true"
import script from "./ModalSendCaseToOrg.vue?vue&type=script&lang=js"
export * from "./ModalSendCaseToOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481535a3",
  null
  
)

export default component.exports